import React from 'react'; 
import './styles.scss'; 
import assets from "../../../Assets"
 
const Modal = ({ children, open, closeModal, modalStyle }) => { 
  const handleClickOutside = (e) => { 
    // Close modal if the user clicks outside of the modal content 
    if (e.target.className === 'modalMain') { 
      closeModal(); 
    } 
  }; 
 
  if(open){ 
    return ( 
        <div className='modalMain'  onClick={handleClickOutside} role="dialog" aria-modal="true"> 
            <div className='modalContent' style={modalStyle}> 
                <div className='modalCloseDiv'> 
                    <span className='modalCloseBtn' onClick={closeModal}><img src={assets.Icons.closeIcon} alt="" /></span> 
                </div> 
                {children} 
            </div> 
        </div> 
      ); 
  }else{ 
    return null 
  } 
}; 
 
export default Modal;